<p-select
  [(ngModel)]="model"
  [options]="orderedOptions"
  [disabled]="disabled"
  [placeholder]="placeholder | translate"
  [optionLabel]="'label'"
  [optionValue]="optionValue"
  [showClear]="showClear"
  [filter]="true"
  [filterFields]="[optionLabel, optionSubtitle]"
  [loading]="loading"
  [style]="{ width: width }"
  [virtualScroll]="true"
  [virtualScrollItemSize]="40"
  [lazy]="true"
  (onChange)="onSelectItem()"
  (onFilter)="onSearch($event)"
  (onShow)="onShow()"
  (onClear)="onClear()"
  (onLazyLoad)="onLazyLoad($event)"
  appendTo="body"
  scrollHeight="250px"
  styleClass="app-dropdown"
  [emptyFilterMessage]="'No data' | translate"
>

  <!-- Custom footer for loading more indicator -->
  <ng-template pTemplate="footer">
    @if (!hasMore && orderedOptions.length > 0) {
      <div class="no-more-items">
        <span>{{ 'All items loaded' | translate }}</span>
      </div>
    }
  </ng-template>

  <ng-template pTemplate="emptyfilter">
    @if (loading) {
      <div class="loading-initial">
        <i class="pi pi-spinner pi-spin"></i>
        <span>{{ 'Loading...'  | translate}}</span>
      </div>
    } @else {
      <div class="no-results">
        <span>{{'No data' | translate}}</span>
      </div>
    }
  </ng-template>

  <ng-template let-option pTemplate="item">
    <div class="option-main text-wrap">
      <div class="option-label">{{ option.label }}</div>
      @if (option.subtitle) {
        <div class="option-subtitle">{{ option.subtitle }}</div>
      }
    </div>
  </ng-template>

  <ng-template pTemplate="selectedItem" let-value>
    <div class="option-main option-main--selected">
      <div class="option-label">{{ value?.label }}</div>
      @if (value.subtitle){
        <div class="option-subtitle">{{ value.subtitle }}</div>
      }
    </div>
  </ng-template>

</p-select>
